import React, { useEffect, useRef, useState } from 'react';

interface Props {
    duration?: number;
    className?: string;
    children: React.ReactNode;
}

const DEFAULT_DURATION = 200;

const HeightAnimationEffect: React.FC<Props> = ({ children, duration = DEFAULT_DURATION, className }) => {
    const measurerRef = useRef<HTMLDivElement | null>(null);
    const [height, setHeight] = useState<number | 'auto'>('auto');

    useEffect(() => {
        if (typeof ResizeObserver !== 'undefined' && measurerRef.current) {
            const observer = new ResizeObserver(([entry]) => setHeight(entry.target.getBoundingClientRect().height));
            observer.observe(measurerRef.current);
            return () => observer.disconnect();
        }
    }, []);

    return (
        <div
            data-role="height-animate"
            style={{ height, transition: `height ${duration}ms`, overflow: 'hidden' }}
            className={className}
        >
            <div data-role="measurer" ref={measurerRef}>
                {children}
            </div>
        </div>
    );
};

export default React.memo(HeightAnimationEffect);
